var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadsShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14896_197806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9496 10.5001L15.0996 4.90005C14.4496 4.40005 13.5496 4.40005 12.8996 4.85005L5.09962 10.2001C4.74962 10.4501 4.64962 10.9001 4.89962 11.2501C5.14962 11.6001 5.59962 11.7001 5.94962 11.4501L6.99962 10.7001V16.8501C6.99962 19.1501 8.84962 21.0001 11.1496 21.0001H16.8496C19.1496 21.0001 20.9996 19.1501 20.9996 16.8501V10.9501L22.0496 11.7001C22.1996 11.8001 22.3496 11.8501 22.4996 11.8501C22.7496 11.8501 22.9496 11.7501 23.0996 11.5501C23.3496 11.2001 23.2496 10.7501 22.9496 10.5001ZM19.4996 16.8501C19.4996 18.3001 18.2996 19.5001 16.8496 19.5001H11.1496C9.69962 19.5001 8.49962 18.3001 8.49962 16.8501V9.65005L13.7996 6.05005C13.8996 5.95005 14.0496 5.95005 14.1996 6.05005L19.4996 9.85005V16.8501Z",
    fill: "#2C2C2C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9496 10.5001L14.0996 4.90005C13.4496 4.40005 12.5496 4.40005 11.8996 4.85005L4.09962 10.2001C3.74962 10.4501 3.64962 10.9001 3.89962 11.2501C4.14962 11.6001 4.59962 11.7001 4.94962 11.4501L5.99962 10.7001V16.8501C5.99962 19.1501 7.84962 21.0001 10.1496 21.0001H15.8496C18.1496 21.0001 19.9996 19.1501 19.9996 16.8501V10.9501L21.0496 11.7001C21.1996 11.8001 21.3496 11.8501 21.4996 11.8501C21.7496 11.8501 21.9496 11.7501 22.0996 11.5501C22.3496 11.2001 22.2496 10.7501 21.9496 10.5001ZM18.4996 16.8501C18.4996 18.3001 17.2996 19.5001 15.8496 19.5001H10.1496C8.69962 19.5001 7.49962 18.3001 7.49962 16.8501V9.65005L12.7996 6.05005C12.8996 5.95005 13.0496 5.95005 13.1996 6.05005L18.4996 9.85005V16.8501Z",
    fill: "#2C2C2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14896_197806",
    x: 0.760742,
    y: 0.518555,
    width: 26.4805,
    height: 24.4814,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_14896_197806"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsShadow);
export default __webpack_public_path__ + "static/media/leads-shadow.5efe57d71a590ca68ed0e32dcdde7648.svg";
export { ForwardRef as ReactComponent };